export const visitListItem = ({
  specialty_name,
  formattedDate,
  excuse_note,
  diagnosis_name
}) => {
  return [
    {
      type: "text",
      title: specialty_name,
      params: "primary"
    },
    {
      type: "text",
      title: formattedDate,
      params: "TDFieldOptionSingleLine"
    },
    {
      type: "text",
      title: diagnosis_name,
      params: "diagnosis-name"
    },
    {
      type: "text",
      title: excuse_note?.note,
      params: "excuse-note"
    }
  ];
};
